import { useCallback, useEffect, useState } from 'react';
import { useClient } from 'hooks/useClient';
import { useQuery } from 'react-query';
import fp from 'lodash/fp';
import { useSession } from 'store/session';
import { IQueryParams, ITeamFolder } from '@cincel/client';
import { getSessionTokenV3 } from 'helpers/sessionContext';


export const useFetchTeamFolders = (
  params: IQueryParams = {},
  initialValues: { page?: number; pageSize: number } = {
    page: 1,
    pageSize: 15,
  },
) => {
  const client = useClient({
    url: process.env.REACT_APP_API_V3,
    token: getSessionTokenV3() as string,
  });

  const [like, setLike] = useState<null | string>(null);

  const [pageSize, setPageSize] = useState<number>(initialValues?.pageSize);

  const [page, setPage] = useState<number>(initialValues?.page as number);

  const { team } = useSession();

  const uuid = team?.uuid as string;

  const fn = useCallback(async () => {
    const response = await client.fetchTeamFolders(uuid, {
      name_like: !fp.isEmpty(like) ? like : null,
      limit: pageSize,
      page: !fp.isEmpty(like) ? initialValues?.page : page,
      sort: 'deleted_at',
      order: 'DESC',
      ...params,
    });

    return {
      count: fp.get(['headers', 'x-total-count'])(response),
      data: fp.get('data')(response) as ITeamFolder[],
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client, like, page, pageSize, uuid]);

  const query = useQuery(['fetch-team-folders', uuid], fn);

  useEffect(() => {
    if (query?.isFetchedAfterMount) query?.refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [like, page, pageSize]);

  return { ...query, like, page, setLike, setPage, pageSize, setPageSize };
};
